import {createRequestActionTypes} from "../../app/utils/request_response_utils/factories/create_request_action_types";
import {fetchVendorList} from "../../application/actions/fetch_vendor_list_at_route";
import {VendorType} from "../../offer/detail/components/agency_and_developer/agency_and_developer_utils";

export const fetchAgencyListActionTypes = createRequestActionTypes({name: "agencyListAgencies", type: "GET", view: "Agencje"});

export const fetchAgencyListAtRoute = fetchVendorList(fetchAgencyListActionTypes, VendorType.AGENCY);
